// FahrerForm shows a form for the user to add input
// import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux'
import { reduxForm, Field } from 'redux-form';
import { bindActionCreators } from 'redux'
import FormField from '../shared/FormField';
import { Link } from 'react-router-dom';
import formFields from './formFields';
import { modalMessage } from '../../actions'

class LoginForm extends Component {

	renderFields() {
		return formFields.map( ({ label, name, type }) =>
		<Field key={name} component={FormField} type={type} label={label} name={name} />
		);
	}

	render () {
		return (
			<div>
				<form onSubmit={this.props.handleSubmit(this.props.onLoginSubmit)}>
					{this.renderFields()}

					{this.props.hinweis && <span>{this.props.hinweis.message}</span>}

					<Link to="/login/requirePassword"
						style={{display: 'block'}}
					>Passwort vergessen?</Link>

				<Link to="/" className="btn btn-secondary white-text">
						Abbrechen
					</Link>

					<button className="btn right white-text" type="submit" style={{marginLeft:'10px'}}>
						Einloggen
					</button>
				</form>
			</div>
		)
	}
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ modalMessage }, dispatch)
  }
}

function validate(values) {
	const errors = {};

	//errors.email = validateEmail(values.email || '');

	//console.log("validate called");
	return errors; // Wenn errors ein leeres Objekte ist, gilt das Formular als richtig validiert.
}

export default reduxForm({
	validate,
	form: 'loginForm',
	destroyOnUnmount: false
})(connect(null, mapDispatchToProps)(LoginForm));



// WEBPACK FOOTER //
// ./src/components/login/LoginForm.js